module.exports = __webpack_public_path__ + "img/img_permisos.3c0d1e4a.png";